import React, { useState, useEffect } from "react";
import { Phone, PhoneX, Clock } from "@phosphor-icons/react";
import API from "../services/api";

export default function Queue() {
  const [queueCalls, setQueueCalls] = useState([]);

  useEffect(() => {
    const fetchQueue = async () => {
      try {
        const { data } = await API.get("/twilio/queue-calls");
        setQueueCalls(data || []);
      } catch {}
    };
    fetchQueue();
    const interval = setInterval(fetchQueue, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleAnswer = (call) => {
    const ds = window.__ds || {};
    ds.dequeueCall?.(call.call_sid, call.queue_sid);
    setQueueCalls(q => q.filter(c => c.call_sid !== call.call_sid));
  };

  const handleDecline = (call) => {
    const ds = window.__ds || {};
    ds.declineQueueCall?.(call.call_sid, call.queue_sid);
    setQueueCalls(q => q.filter(c => c.call_sid !== call.call_sid));
  };

  const isInCall = window.__ds?.isInCall;

  const formatWait = (enqueued_at) => {
    if (!enqueued_at) return "0s";
    const secs = Math.floor((new Date() - new Date(enqueued_at)) / 1000);
    if (secs < 60) return `${secs}s`;
    return `${Math.floor(secs / 60)}m ${secs % 60}s`;
  };

  return (
    <div style={{ padding: 24, height: "100%", overflow: "auto", fontFamily: "var(--font-primary)" }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Call Queue</h1>
          <p className="page-subtitle">{queueCalls.length} waiting</p>
        </div>
      </div>

      <div className="card" style={{ marginTop: 16 }}>
        <div className="card-header">
          <h3>Waiting Now</h3>
          <span className="badge" style={{
            background: queueCalls.length > 0 ? "rgba(236,108,33,0.2)" : "var(--color-surface)",
            color: queueCalls.length > 0 ? "var(--color-orange)" : "var(--color-gray)",
            border: `1px solid ${queueCalls.length > 0 ? "rgba(236,108,33,0.4)" : "var(--color-surface-mid)"}`,
            padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600,
          }}>
            {queueCalls.length} in queue
          </span>
        </div>

        {queueCalls.length === 0 ? (
          <div className="empty-state" style={{ padding: "40px 0" }}>
            <Phone size={32} style={{ opacity: 0.2 }} />
            <p>No calls waiting in queue.</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: "0 4px" }}>
            {queueCalls.map((call, i) => (
              <div key={call.call_sid} style={{
                display: "flex", alignItems: "center", gap: 16,
                padding: "14px 16px",
                background: i === 0 ? "rgba(236,108,33,0.08)" : "var(--color-surface)",
                borderRadius: 8,
                border: `1px solid ${i === 0 ? "rgba(236,108,33,0.3)" : "var(--color-surface-mid)"}`,
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: i === 0 ? "rgba(236,108,33,0.2)" : "var(--color-surface-mid)",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                  <span style={{ fontWeight: 700, fontSize: 13, color: i === 0 ? "var(--color-orange)" : "var(--color-gray)" }}>#{i + 1}</span>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14, color: "var(--color-white)", fontFamily: "var(--font-mono)" }}>
                    {call.from_number || call.call_sid}
                  </div>
                  <div style={{ fontSize: 12, color: "var(--color-gray)", display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}>
                    <Clock size={11} /> Waiting {formatWait(call.enqueued_at)}
                  </div>
                </div>
                {i === 0 && !isInCall && (
                  <div style={{ display: "flex", gap: 8 }}>
                    <button className="btn btn-primary btn-sm" onClick={() => handleAnswer(call)}>
                      <Phone size={13} weight="fill" /> Answer
                    </button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleDecline(call)}>
                      <PhoneX size={13} /> Decline
                    </button>
                  </div>
                )}
                {i === 0 && isInCall && (
                  <span style={{
                    fontSize: 11, color: "var(--color-orange)",
                    background: "rgba(236,108,33,0.1)", padding: "4px 10px",
                    borderRadius: 20, border: "1px solid rgba(236,108,33,0.3)",
                  }}>Next up</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
